import sliceCreator from '../../index.jsx';
import {GET_ALL_DEALERS} from '../../../constants/index.jsx';
const _getAllDealersAction = sliceCreator('GET_ALL_DEALERS', GET_ALL_DEALERS, 'get');

const { asyncAction: getAllDealersAction, reducer, clearData: clearGetAllDealersAction } = _getAllDealersAction;

export default reducer;

export {
    getAllDealersAction,
    clearGetAllDealersAction
}